import { useQuery } from '@tanstack/react-query';
import { dataCentralApi } from '@/api/client';

/**
 * The signed-in partner's own contact record from DataCentral
 * (GET /partner/auth/me → result.user.contact). Used to pre-fill contact/lead
 * forms. Only the fields the contact table exposes are surfaced — company name
 * is not on the contact (it holds a company_id), and website is not stored.
 */
export interface MyContact {
  name?: string;
  email?: string;
  phone?: string;
  /** Job title (contact_position). */
  position?: string;
}

export function useMyContact() {
  return useQuery({
    queryKey: ['dc', 'my-contact'],
    staleTime: 5 * 60_000,
    retry: false,
    queryFn: async (): Promise<MyContact | null> => {
      const res = await dataCentralApi.get('/partner/auth/me');
      const c = res.data?.result?.user?.contact as
        | { contact_name?: string; contact_email?: string; contact_phone?: string; contact_position?: string }
        | undefined;
      if (!c) return null;
      return {
        name: c.contact_name || undefined,
        email: c.contact_email || undefined,
        phone: c.contact_phone || undefined,
        position: c.contact_position || undefined,
      };
    },
  });
}
